// removed by extract-text-webpack-plugin
module.exports = {"layoutGrid":"src-layouts----index-module---layoutGrid---qIM4-","high":"src-layouts----index-module---high---2z6vi"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/index.module.css
// module id = 113
// module chunks = 114276838955818 162898551421021